export const ProfileInformationConstant = {
    StoreSliceName: 'profileInformation',
};
